
import { defineComponent, SetupContext, getCurrentInstance, PropType, computed, onMounted, watch } from 'vue';
import Popup from 'vant/lib/popup';
import Toast from 'vant/lib/toast';
import { copyToClipboard } from '@/common/utils';
import { AIFeedPageEnum } from '@/store/modules/ai-feed';
import { AIFeed } from '@/api/ai-feed';
import { AISelectedMessageInfo } from '@/store/modules/ai-conversation';
import { sendLog } from '@/common/radar';

const MessageActionPopup = defineComponent({
    components: {
        Popup,
    },
    props: {
        isShow: {
            type: Boolean,
            default: false,
        },
        feedPage: {
            type: String as PropType<AIFeedPageEnum> | undefined,
            default: AIFeedPageEnum.AIForyou,
        },
        currentFeed: {
            type: Object as PropType<AIFeed> | undefined,
            default: undefined,
        },
    },
    setup(props, ctx: SetupContext<Array<'onCancel'>>) {
        const { proxy } = getCurrentInstance() || {};

        const messageIndex = computed(() => {
            return (proxy?.$store?.state?.conversationModule?.selectedMessageInfo as AISelectedMessageInfo)?.messageIndex || 0;
        });

        const handleCancel = () => {
            ctx.emit('onCancel');
        };

        const handleClickLog = (type?: 'report' | 'cancel' | 'copy') => {
            if (!type) {
                return;
            }

            const botId = proxy?.$store?.state?.conversationModule?.selectedMessageInfo?.botId;

            sendLog({
                type: 'click',
                name: 'MESSAGE_FEEDBACK_POPUP',
                value: {
                    click_area: type,
                    bot_id: botId,
                    message_index: Number(messageIndex.value) + 1,
                },
            });
        };

        const actionList = computed(() => {
            return [
                {
                    title: proxy?.$root?.$t?.('report_button') as string,
                    onClick: () => {
                        handleClickLog('report');
                        const botId = proxy?.$store?.state?.conversationModule?.selectedMessageInfo?.botId;
                        const query = proxy?.$route?.query || {};
                        proxy?.$router?.push?.({
                            path: `/aichat/report`,
                            query: { ...query, feedPage: props.feedPage, botId },
                        });
                        handleCancel();
                    },
                },
                {
                    title: proxy?.$root?.$t?.('copy') as string,
                    onClick: () => {
                        handleClickLog('copy');
                        copyToClipboard(proxy?.$store?.state?.conversationModule?.selectedMessageInfo?.content || '');
                        Toast({
                            message: proxy?.$root?.$t?.('k_446636'),
                        });
                        handleCancel();
                    },
                },
                {
                    title: proxy?.$root?.$t?.('AlbumCard_Authorize_popup_cancel') as string,
                    onClick: () => {
                        handleClickLog('cancel');
                        handleCancel();
                    },
                },
            ];
        });

        const finalActionList = computed(() => {
            if (props?.currentFeed?.bot_id_str === '738470468051295297') {
                return actionList.value.filter(item => item.title !== (proxy?.$root?.$t?.('report_button') as string));
            } else {
                return actionList.value;
            }
        });

        return { actionList, messageIndex, finalActionList };
    },
});

export default MessageActionPopup;
